export default __webpack_public_path__ + "static/media/10_skaceni-stromu.83e6c389.jpg";